import type { WidgetDefinition } from "@nexus/widget-sdk";
import { manifest, Component, defaultConfig } from ".";

export const definition: WidgetDefinition = {
  id: "social-media-posts",
  module: { manifest, Component, defaultConfig },
  catalog: {
    description: "Social-media chatter observed around one protected event's piracy activity.",
    domain: "reports",
    visual: "Feed",
    purposes: ["reporting"],
    reportEdition: true,
    audiences: ["analyst", "client"],
  },
  layout: { skeleton: "list" },
  defaultLayoutClassName: "col-span-12",
};
